import { CheckinButtonModule, ProgressTrackerModule } from '@my-account/components';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertErrorFilled,
	homefieldIconAlertInfoFilled,
	homefieldIconBuildingStoreDsgAlt,
	homefieldIconDsgStorePickup,
	homefieldIconGgStorePickup,
	homefieldIconGggStorePickup,
	homefieldIconOrderDelivery,
	homefieldIconPlStorePickup,
	homefieldIconSignCheck,
	homefieldIconVehicleShipping
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HmfAlertBannerComponent } from '@dsg-tech/homefield-angular';
import { HomefieldButtonModule } from '@homefield';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from '@shared/components';
import { PurchaseListV2Component } from './purchase-list-v2.component';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [PurchaseListV2Component],
	imports: [
		CheckinButtonModule,
		CommonModule,
		HmfAlertBannerComponent,
		HomefieldButtonModule,
		HomefieldIconLibraryModule,
		MatExpansionModule,
		ProgressSpinnerModule,
		ProgressTrackerModule,
		RouterModule
	],
	exports: [PurchaseListV2Component]
})
export class PurchaseListV2Module {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertErrorFilled, homefieldIconAlertInfoFilled, homefieldIconVehicleShipping,
			homefieldIconBuildingStoreDsgAlt, homefieldIconDsgStorePickup, homefieldIconGgStorePickup,
			homefieldIconGggStorePickup, homefieldIconPlStorePickup, homefieldIconOrderDelivery, homefieldIconSignCheck]);
	}
}
